export const TARGET_FRAMERATE = 60;
export const TARGET_RENDER_FRAMETIME = 1 / TARGET_FRAMERATE;
export const BOID_BOUNDS = 80;
export const BOID_COUNT = 100;
export const MAX_TARGET_HIT = 30;

// in order WHITE, RED, ORANGE, YELLOW, GREEN, LIGHT BLUE, BLUE,PURPLE, PINK
export const BOID_COLOR_LIST = [ 0xffffff, 0xffc2c2, 0xffe7c2, 0xfff7c2, 0xefffc2, 0xc2ffec, 0xc2d6ff, 0xdcc2ff, 0xffc2f9]
